import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IVerifyCloudIntegrationApiKeyParams {
    tsId?: string;
    apiKey?: string;
    apiKeySettingName: string;
}

export class VerifyCloudIntegrationApiKeyRequest extends Request<IVerifyCloudIntegrationApiKeyParams, IResult> {
  constructor(params: IVerifyCloudIntegrationApiKeyParams) {
    super('validateApiKey', params);
  }
}